import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Weekly Analysis Day and Hours',
    },
  },
};

const labels = ['MON','TUE','WED','THU','FRI','SAT','SUN'];

export const data = {
  labels,
  datasets: [
    {
      label: 'This Week',
      data: labels.map(() => faker.datatype.number({ min: 0, max: 24 })),
      backgroundColor: '#9648ad',
      barThickness:30
    },
    {
        label: 'Previous Week',
        data: labels.map(() => faker.datatype.number({ min: 0, max: 24 })),
        backgroundColor: '#5d44de',
        barThickness: 30
      }
  ],
};

export default function BarGraph() {
  return <Bar options={options} data={data} />;
}
